import { useTypedQuery } from "hooks";
import { UsersDashboardQueryKeys } from "modules/UsersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useMetricsQuery = (userId: number | null) =>
  useTypedQuery({
    queryKey: UsersDashboardQueryKeys.metrics,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, { user_id: userId ?? 0 }, baseUrl)).data.network_metrics,
    enabled: !!userId,
    initialData: []
  });
